module.exports = __webpack_public_path__ + "static/img/swiper2.7fdb4ea8.webp";